import React, { Component } from "react";
import PropTypes from "prop-types";
import { AuthorizedOwner, ConfirmDelete } from "MODULES/shared/components";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import * as actions from "../../actions";

export class AttachmentTag extends Component {
  state = {
    open: false
  };

  handleClick = e => {
    this.open();
    e.stopPropagation();
  };

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  render() {
    const { attachment, index, destroy } = this.props;
    const str = `Img #${index + 1}`;
    return (
      <div className="btn-group" style={{ marginRight: "5px" }}>
        <button
          className="btn btn-xs btn-default"
          onClick={e => e.stopPropagation()}
        >
          <a href={`${attachment.file_url}`}>{str}</a>
        </button>
        <AuthorizedOwner record={fromJS(attachment)}>
          <button
            type="button"
            className="btn btn-xs btn-default"
            onClick={this.handleClick}
          >
            <span style={{ marginLeft: 3 }}>
              <i className="fa fa-close text-danger" />
            </span>
          </button>
        </AuthorizedOwner>
        <ConfirmDelete
          onConfirm={() => destroy(attachment.id)}
          close={this.close}
          open={this.state.open}
        >
          <strong>Heads up!</strong> Are you sure you want to delete this?
        </ConfirmDelete>
      </div>
    );
  }
}

AttachmentTag.propTypes = {
  attachment: PropTypes.shape({
    file_url: PropTypes.string,
    id: PropTypes.number
  }).isRequired,
  destroy: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default connect(undefined, {
  destroy: actions.destroyAttachment
})(AttachmentTag);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/AttachmentTag.jsx